import { render, staticRenderFns } from "./DetailDeposit.vue?vue&type=template&id=fd979002&scoped=true&"
import script from "./DetailDeposit.vue?vue&type=script&lang=ts&"
export * from "./DetailDeposit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd979002",
  null
  
)

export default component.exports